//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import seguroEmpateMixin from '~/mixins/seguro-empate'

export default {
  name: 'ElementsSeguroEmpateTooltip',
  mixins: [seguroEmpateMixin],
  props: {
    visible: { type: Boolean, default: false },
    event: { default: null }
  },
  computed: {
    config() {
      return this.seguroEmpateConfigFor(this.event)
    },
    minOdds() {
      const raw =
          _.get(this.config, 'minimum_odds_per_selection') ||
          _.get(this.config, 'min_odd')
      return raw ? parseFloat(raw) : null
    },
    minAmount() {
      const raw = _.get(this.config, 'minimum_bet_amount')
      return raw ? parseFloat(raw) : null
    },
    requirements() {
      const req = [
        this.$t('DRAW_INSURANCE_SINGLE_BETS_MATCH_RESULT_ONLY'),
        this.$t('DRAW_INSURANCE_PRE_MATCH_BETS_ONLY')
      ]
      if (this.minOdds) {
        req.push(`${this.$t('DRAW_INSURANCE_MINIMUM_ODDS')}: ${this.minOdds.toFixed(2)}`)
      }
      if (this.minAmount) {
        req.push(`${this.$t('DRAW_INSURANCE_MINIMUM_BET_AMOUNT')}: ${this.format_money(this.minAmount * 100)}`)
      }
      req.push(this.$t('DRAW_INSURANCE_FREEBET_AMOUNT_SUBJECT_TO_PROMOTION_LIMIT'))
      return req
    }
  }
}
